import { MNSproCloudApi } from '..';
import { AzureCourse, GroupRole } from '../api/v2';
import { differenceBy } from 'lodash';

const getApi = (authToken: string) =>
  MNSproCloudApi.V2.CoursesApiFactory(
    MNSproCloudApi.V2.createConfiguration(authToken),
  );

export class CourseSubscriptionService {
  static async getSubscribedCourses(
    authToken: string,
    organizationId: string,
    period?: string,
  ): Promise<AzureCourse[]> {
    const api = getApi(authToken);
    return (await api.getAll(organizationId, period)).data;
  }
  static async getNotSubscribedCourses(
    organizationId: string,
    authToken: string,
    period?: string,
  ): Promise<AzureCourse[]> {
    const [allCourses, subscribedCourses] = await Promise.all([
      (
        await MNSproCloudApi.V2.UserGroupsApiFactory(
          MNSproCloudApi.V2.createConfiguration(authToken),
        ).getAll(organizationId, GroupRole.course, undefined, period)
      ).data,
      await CourseSubscriptionService.getSubscribedCourses(
        authToken,
        organizationId,
        period,
      ),
    ]);

    return differenceBy(allCourses, subscribedCourses, course => course.id).map(
      course => {
        return {
          id: course.id,
          createdDateTime: course.createdDateTime,
          displayName: course.name,
          isInProvisioningTimeWindow: course.isInProvisioningTimeWindow,
          mail: course.mail,
          mailNickname: course.mailNickname,
          timePeriod: course.timePeriod,
        } as AzureCourse;
      },
    );
  }
  static async subscribeCourse(
    authToken: string,
    organizationId: string,
    courseId: string,
  ): Promise<AzureCourse> {
    const api = getApi(authToken);
    return (await api.join(courseId, organizationId)).data;
  }
  static async unsubscribeCourse(
    authToken: string,
    organizationId: string,
    courseId: string,
  ): Promise<AzureCourse> {
    const api = getApi(authToken);
    return (await api.leave(courseId, organizationId)).data;
  }
}
